import React, { PureComponent } from 'react';
import PageHeaderMenu from './page-header-menu';
import { PageHeaderBaseMenuConfig } from './page-header.consts';

import nexarDevelopersLogoUrl from '../../assets/images/nexar_developers.svg';
import './page-header.scss';
import history from '../../core/history';
import { track, TrackedEvent } from '../../core/analytics';

class PageHeader extends PureComponent {
  windowResizeHandler() {
    document.getElementById('header_nav')['checked'] = false;
  }

  documentClickHandler(e) {
    if (e.target.id === 'header_nav_label') {
      return;
    }
    if (e.target.id !== 'header_nav' && document.getElementById('header_nav')['checked'] === true) {
      document.getElementById('header_nav')['checked'] = false;
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.windowResizeHandler);
    document.addEventListener('click', this.documentClickHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.windowResizeHandler);
    document.removeEventListener('click', this.documentClickHandler);
  }

  render() {
    return (
      <header className="site-header">
        <div className="container">
          <div className="row">
            <div className="two columns">
              <div className="brand">
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    track(TrackedEvent.pageHeaderBrandIconClicked);
                    history.push('/');
                  }}
                >
                  <img className="logo" src={nexarDevelopersLogoUrl} alt="Nexar" />
                </a>
              </div>
              <div className="menu-toggle">
                <label id="header_nav_label" htmlFor="header_nav">
                  Menu
                </label>
              </div>
            </div>
            <input
              type="checkbox"
              id="header_nav"
              className="menu-toggle-checkbox"
              onChange={() => {
                track(TrackedEvent.pageHeaderCollapsedMenuToggle);
              }}
            />
            <nav className="ten columns" role="navigation">
              <PageHeaderMenu config={PageHeaderBaseMenuConfig} />
            </nav>
          </div>
        </div>
      </header>
    );
  }
}

export default PageHeader;
